import { chakra } from '@chakra-ui/react';

export * from './snippets';
export * from './TestThemeProvider';
export { breakpoints, system } from './theme';
export * from './ThemeProvider';
export * from './token-hooks';
export type {
  AccordionItemContentProps,
  AccordionItemProps,
  // Extended and exported from snippets
  // AccordionItemTriggerProps,
  BoxProps,
  // Extended and exported from snippets
  // BreadcrumbItemProps,
  // Extended and exported from snippets
  // BreadcrumbLinkProps
  // Extended and exported from snippets
  // ButtonProps,
  SkeletonProps as ChakraSkeletonProps,
  CheckboxCheckedChangeDetails,
  CircleProps,
  CollapsibleContentProps,
  DialogActionTriggerProps,
  DialogBackdropProps,
  DialogBodyProps,
  DialogCloseTriggerProps,
  DialogDescriptionProps,
  DialogFooterProps,
  DialogHeaderProps,
  // Extended and exported from snippets
  // DialogContentProps,
  DialogRootProps,
  DialogTitleProps,
  DialogTriggerProps,
  DrawerActionTriggerProps,
  DrawerBackdropProps,
  DrawerBodyProps,
  // Extended and exported from snippets
  // DrawerContentProps,
  DrawerCloseTriggerProps,
  DrawerDescriptionProps,
  DrawerFooterProps,
  DrawerHeaderProps,
  DrawerTitleProps,
  DrawerTriggerProps,
  EditablePreviewProps,
  // Extended and exported from snippets
  // FieldLabelProps,
  FieldErrorTextProps,
  InputElementProps,
  InputProps,
  LinkProps,
  MenuArrowProps,
  MenuCheckboxItemProps,
  // Extended and exported from snippets
  //MenuContentProps,
  MenuContextTriggerProps,
  MenuItemCommandProps,
  MenuItemGroupProps,
  MenuItemProps,
  MenuItemTextProps,
  MenuRadioItemGroupProps,
  MenuRadioItemProps,
  MenuRootProps,
  MenuSeparatorProps,
  // Extended and exported from snippets
  //MenuTriggerItemProps,
  MenuTriggerProps,
  PopoverArrowProps,
  PopoverCloseTriggerProps,
  PopoverDescriptionProps,
  PopoverTitleProps,
  // Extended and exported from snippets
  // PopoverContentProps,
  // Extended and exported from snippets
  // ProgressLabelProps,
  ProgressRootProps,
  SimpleGridProps,
  SliderRangeProps,
  SliderTrackProps,
  StackProps,
  // Extended and exported from snippets
  // StatLabelProps,
  // Extended and exported from snippets
  // StatValueTextProps,
  StatRootProps,
  TabsRootProps,
  // Extended and exported from snippets
  // StepsItemProps
  // Extended and exported from snippets
  // StepsIndicatorProps,
  TextareaProps,
  TextProps,
  Tokens,
} from '@chakra-ui/react';

// For all namespaces, prefer using corresponding snippet for most common use cases
export {
  AbsoluteCenter,
  AspectRatio,
  Badge,
  Box,
  Center,
  Accordion as ChakraAccordionNamespace,
  Alert as ChakraAlertNamespace,
  Breadcrumb as ChakraBreadcrumbNamespace,
  Button as ChakraButton,
  Checkbox as ChakraCheckboxNamespace,
  Dialog as ChakraDialogNamespace,
  Drawer as ChakraDrawerNamespace,
  Field as ChakraFieldNamespace,
  Menu as ChakraMenuNamespace,
  NumberInput as ChakraNumberInputNamespace,
  Popover as ChakraPopoverNamespace,
  Progress as ChakraProgressNamespace,
  RadioGroup as ChakraRadioGroupNamespace,
  Skeleton as ChakraSkeleton,
  Slider as ChakraSliderNamespace,
  Stat as ChakraStatNamespace,
  Steps as ChakraStepsNamespace,
  Switch as ChakraSwitchNamespace,
  Table as ChakraTableNamespace,
  Tag as ChakraTagNamespace,
  CheckboxGroup,
  Circle,
  Clipboard,
  Collapsible,
  Container,
  createIcon,
  Editable,
  EditableInput,
  EditablePreview,
  EditableTextarea,
  Fieldset,
  Flex,
  For,
  Grid,
  GridItem,
  Group,
  Heading,
  Highlight,
  HStack,
  Image,
  Input,
  InputAddon,
  InputElement,
  Link,
  LinkBox,
  LinkOverlay,
  List,
  Portal,
  Presence,
  Separator,
  SimpleGrid,
  Spacer,
  Span,
  Spinner,
  Stack,
  Tabs,
  Text,
  Textarea,
  useChakraContext,
  useDisclosure,
  useMediaQuery,
  useTableStyles,
  VisuallyHidden,
  VStack,
  Wrap,
} from '@chakra-ui/react';

export const ColGroup = chakra.colgroup;
export const UnorderedList = chakra.ul;
export const OrderedList = chakra.ol;
export const ListItem = chakra.li;
export const IFrame = chakra.iframe;
